import { images } from "assets/images";
import { useTranslation } from "react-i18next";
import FormatReportDetails, {
  getStatusColor,
} from "common/helpers/reportsHelper";
import { useRole } from "hooks/useRole";
import { KeyValueObject } from "models/KeyValueObject";
import { ReportModel } from "models/ReportModel";
import React, { Dispatch, SetStateAction } from "react";
import { Form, Image } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { UserRole } from "components/Reports/reportAssets/assets";
import { useLocationForReportType } from "hooks/useLocationForReportType";
import { useDispatch } from "react-redux";
import { setReportId } from "store/slices/reportsSlice";
import Tag from "../Tag/tag";
import ReportDetailsField from "./reportDetailsField";
import { RenderTagsWithOnHOverOption } from "./reportBoxUtils";

type ReportBoxProps = {
  report: ReportModel;
  statuses;
  checkedReportsIds: number[];
  setCheckedReportsIds: Dispatch<SetStateAction<number[]>>;
};

const ReportBox = ({
  report,
  checkedReportsIds,
  setCheckedReportsIds,
  statuses,
}: ReportBoxProps) => {
  const { t } = useTranslation();
  const {
    id,
    isForImmediateTreatment,
    isReversedDecision,
    isDuplicate,
    duplicatedReportsIds,
    isOrigin,
    originReportId,
    reportStatus: status,
  } = report;
  const role = useRole();
  const isFollowUp = useLocationForReportType() === "followup";
  const dispatch = useDispatch();
  const location = useLocation();

  const dataReportDetails = FormatReportDetails(report, role);

  const getStatusById = () => {
    const reportStatus = statuses.length
      ? statuses.find((sta) => sta.ids.includes(status))
      : null;

    return reportStatus;
  };

  const reportStatus = getStatusById();

  const fieldClassName = () => {
    if (isDuplicate) {
      return "whiteContainer boxCon dashed-border";
    }

    return "whiteContainer boxCon";
  };

  const renderExtraData = () => {
    if (isOrigin && duplicatedReportsIds?.length) {
      return (
        <div className="reportType">
          ({duplicatedReportsIds?.length} {t("duplicatedReports")})
        </div>
      );
    }
    if (isDuplicate) {
      return (
        <div className="reportType">
          ( {t("originReport")} - {originReportId} )
        </div>
      );
    }

    return null;
  };

  const handleCheckboxClick = (reportId: number) => {
    if (checkedReportsIds.includes(reportId)) {
      // If the ID is already in the array, remove it
      setCheckedReportsIds(
        checkedReportsIds.filter((checkedId) => checkedId !== reportId)
      );
    } else {
      // If the ID is not in the array, add it
      setCheckedReportsIds([...checkedReportsIds, reportId]);
    }
  };

  return (
    <Link
      to={`${location.pathname}/${id}`}
      className="reportBox"
      key={id}
      onClick={() => dispatch(setReportId(id))}
    >
      <div className={fieldClassName()}>
        <div className="rigthBoxCon">
          <div className="titleReportBox">
            {isForImmediateTreatment && (
              <Image
                src={images.forImmediateTreatment}
                alt={t("forImmediateTreatment")}
              />
            )}
            {isFollowUp && role === UserRole.CONTROLCENTER && (
              <Form.Check
                key={id}
                className="report-checkbox"
                id={id.toString()}
                type="checkbox"
                defaultChecked={checkedReportsIds.includes(id)}
                onClick={(e) => {
                  e.stopPropagation();
                  handleCheckboxClick(
                    Number((e.target as HTMLInputElement).id)
                  );
                }}
              />
            )}
            <span className="titleText">{t("labelReportNumber")}</span>
            <span className="numText">{id}</span>
            {renderExtraData()}
            <Tag
              isBtn={false}
              color={getStatusColor(reportStatus?.ids?.[0] ?? status, role)}
              active
              text={reportStatus ? reportStatus?.type : ""}
              onClickHandle={() => {}}
            />
          </div>

          <div className="detailItems">
            {dataReportDetails.map(
              (detail: KeyValueObject) =>
                detail && (
                  <ReportDetailsField
                    key={detail.label}
                    detail={detail}
                    isReversedDecision={isReversedDecision}
                  />
                )
            )}
          </div>
        </div>

        <div className="leftBoxCon">
          <p className="title">{t("labelTags")}</p>
          {RenderTagsWithOnHOverOption({ reportTagsArray: report.tags })}
        </div>
      </div>
    </Link>
  );
};

export default ReportBox;
